/* eslint-disable sonarjs/cognitive-complexity */

import React from 'react';
import { IconWrapper, StyledButton } from "./style";
import { useColorsConfig } from '../../hooks/useColorsConfig';

const CommonButton = ({
  children,
  variant = 'primary',
  icon,
  iconPosition = 'left',
  iconLeft,
  iconRight,
  disabled = false,
  onClick,
  backgroundColor,
  type = 'button',
  foregroundColor = '#fff',
  isBold = false,
  ...props
}) => {
  const {
    colors: { primary },
  } = useColorsConfig();

  const displayIcon = icon || iconLeft || iconRight;
  const position = icon ? iconPosition : (iconLeft ? 'left' : 'right');

  return (
    <StyledButton
      variant={variant}
      disabled={disabled}
      isBold={isBold}
      onClick={onClick}
      backgroundColor={backgroundColor ?? primary}
      foregroundColor={foregroundColor}
      type={type}
      {...props}
    >
      {displayIcon && position === 'left' && <IconWrapper>{displayIcon}</IconWrapper>}
      {children}
      {displayIcon && position === 'right' && <IconWrapper>{displayIcon}</IconWrapper>}
    </StyledButton>
  );
};

export default CommonButton;
